









































































































































































import VueOptions from '@utils/VueOptions'
import PricingModel from '@services/PricingModel'
import SuperContainerView from '@superUI/Containers/SuperContainerView'
import PromptModal from '@components/PromptModal'
import LoadingIndicator from '@components/LoadingIndicator'
import Back from '@modules/ui/buttons/Back'

import SuperBar from '@modules/ui/Event/actions/SuperBar'
import PokeBar from '@modules/ui/Event/actions/PokeBar'
import PotentialBar from '@modules/ui/Event/actions/PotentialBar'
import NextEventBar from '@modules/ui/Event/actions/NextEventBar'
import PublishBar from '@modules/ui/Event/actions/PublishBar'
import MoreActionsBar from '@modules/ui/Event/actions/MoreActionsBar'

import EventHeader from '@modules/ui/Event/EventHeader'
import Super from '@modules/ui/Event/sections/Super'
import Overview from '@modules/ui/Event/sections/Overview'
import Promotional from '@modules/ui/Event/sections/Promotional'
import Onsite from '@modules/ui/Event/sections/Onsite'
import BrandOffer from '@modules/ui/Event/sections/BrandOffer'

import EventAlertBar from './EventAlertBar'
import OrganizerEventAlertBar from '@hostComponents/Event/EventAlertBar'
import SponsorEventAlertBar from '@sponsorComponents/Event/EventAlertBar'

import CopyEventTriggerModal from '@triggers/Event/CopyEventTriggerModal'
import UpdatePricingModelTriggerModal from '@triggers/Event/UpdatePricingModelTriggerModal'

import SetGeoFenceTimeFrameTriggerModal from '@triggers/Event/SetGeoFenceTimeFrameTriggerModal'
import RecommendToCampaignsTriggerModal from '@triggers/Campaign/RecommendToCampaignsTriggerModal'

import TransferEventTriggerModal from '@triggers/Event/TransferEventTriggerModal'

settings =
  name: "EventShow"
  components: { 'event-alert-bar' : EventAlertBar, 'organizer-event-alert-bar' : OrganizerEventAlertBar, 'sponsor-event-alert-bar' : SponsorEventAlertBar, PromptModal, SuperBar,
    PokeBar,
     SuperContainerView,
     PotentialBar,
     NextEventBar,
     PublishBar,
     MoreActionsBar,
     EventHeader,
     Super,
     Overview,
    Promotional,
     Onsite,
     BrandOffer,
     LoadingIndicator,
     Back,
     CopyEventTriggerModal,
     UpdatePricingModelTriggerModal,
     SetGeoFenceTimeFrameTriggerModal,
     RecommendToCampaignsTriggerModal
     TransferEventTriggerModal
  }
  resources:
    event:
      resourceName: "event"
      slug: "events/:eventId"
  vue:
    props: ['eventId']
    data: ->
      actionModal:
        show: false
        title: ''
        button:
          label: ''
          handler: null

      projectNextEventModal:
        modalOptions:
          title: 'Project Event For Next Year'
          button:
            label: 'Project Event'

      memberNoteModal:
        modalOptions:
          title: 'Add Member Note'
          inputField:
            label: 'Member Note'
            type: 'el-input'
            model: 'note'
          button:
            label: 'Add'
      superNoteModal:
        modalOptions:
          title: 'Add Super Note'
          inputField:
            label: 'Super Note'
            type: 'el-input'
            model: 'note'
          button:
            label: 'Add'

      publicTagModal:
        modalOptions:
          title: 'Add Public Tag'
          inputField:
            label: 'Tag'
            type: 'el-input'
            model: 'tag'
          button:
            label: 'Add'
      privateTagModal:
        modalOptions:
          title: 'Add Private Tag'
          inputField:
            label: 'Tag'
            type: 'el-input'
            model: 'tag'
          button:
            label: 'Add'
      untagModal:
        modalOptions:
          title: 'Remove this tag?'
          button:
            label: 'Untag'

      privateFlagModal:
        modalOptions:
          title: 'Add Private Flag'
          inputField:
            label: 'Flag'
            type: 'el-input'
            model: 'flag'
          button:
            label: 'Add'
      unflagModal:
        modalOptions:
          title: 'Remove this flag?'
          button:
            label: 'Unflag'

    computed:
      tagBg: ->
        switch @event.state
          when 'draft' then 'bg-draft'
          when 'listed' then 'bg-success'
      canPublish: -> @event.tags.length is 0 && @event.state is 'draft'
      eventSpacesAsArray: () ->
        return [] unless @event?.spaces?
        arrayed = []
        arrayed.push(obj) for key, obj of @event.spaces
        arrayed
      hasMultipleEvents: -> @event?.event_set.event_series.length > 1
      mapOptions: ->
        draggable: false
        zoomControl: false
        mapTypeControl: false
        scaleControl: false
        streetViewControl: false
        rotateControl: false
        fullscreenControl: false
        disableDefaultUi: true
      nextEvent: ->
        currentIndex = @event.occurrence_index
        nextEvent = (@event.event_set.event_series.filter (e) -> e.occurrence_index is currentIndex + 1)[0]
        nextEvent || false
      previousEvent: ->
        currentIndex = @event.occurrence_index
        previousEvent = (@event.event_set.event_series.filter (e) -> e.occurrence_index is currentIndex - 1)[0]
        previousEvent || false
      isPastEvent: -> dayjs(@event.local_start_day).isBefore(dayjs()) && @event.state is 'listed'

      spaces: ->
        sampling: @eventSpacesAsArray.filter (e) -> e.category is 'sampling'
        booths: @eventSpacesAsArray.filter (e) -> e.category is 'booth'
        trucks: @eventSpacesAsArray.filter (e) -> e.category is 'truck'
        media: @eventSpacesAsArray.filter (e) -> e.category is 'media'
        nativeIntegrations: @eventSpacesAsArray.filter((e) -> e.type == 'native_integration')
        socialPosts: @eventSpacesAsArray.filter((e) -> e.type == 'social_media_post')

      transferTriggerResource: ->
        _this = this
        { key: 'event', triggerName: 'transfer_ownership', component: _this }

      memberNoteTriggerResource: ->
        { key: 'event', triggerName: 'add_member_note', component: this }
      superNoteTriggerResource: ->
        { key: 'event', triggerName: 'add_super_note', component: this }

      memberNotePayload: ->
        payload =
          options:
            note: ''
        payload
      superNotePayload: ->
        payload =
          options:
            note: ''
        payload

      publicTagTriggerResource: ->
        { key: 'event', triggerName: 'add_public_tag', component: this }
      privateTagTriggerResource: ->
        { key: 'event', triggerName: 'add_private_tag', component: this }
      untagTriggerResource: ->
        { key: 'event', triggerName: 'untag', component: this }
      publicTagPayload: ->
        payload =
          options:
            tag: ''
        payload
      privateTagPayload: ->
        payload =
          options:
            tag: ''
        payload

      privateStatusFlagTriggerResource: ->
        { key: 'event', triggerName: 'add_private_status_flag', component: this }
      privateStatusFlagPayload: ->
        payload =
          options:
            flag: ''
        payload
      unflagTriggerResource: ->
        { key: 'event', triggerName: 'unflag', component: this }

      autoProjectingTriggerResource: ->
        { key: 'event', triggerName: 'configure_auto_projecting', component: this }

    methods:
      copyEventTrigger: (payloadOptions) ->
        @$refs.copyEventTrigger.fire(payloadOptions, { originalName: @event.name })
      onEventCopyEvent: (data, response) ->
        @$refs.copyEventTrigger.close()
        @$router.push({ name: 'EventShowPage', params: { eventId: response.id, tab: 'overview'} })

      transferEventTrigger: () ->
        modalOptions = { currentEvent: @event }
        @$refs.transferEventTrigger.fire({}, modalOptions)
      onEventTransferEvent: ->
        @$refs.transferEventTrigger.close()

      hiSetGeoFenceTimeFrameTrigger: ->
        @$refs.setGeoFenceTimeFrameTrigger.fire()
      onEventSetGeoFenceTimeframe: ->
        @$refs.setGeoFenceTimeFrameTrigger.close()
      hiUpdatePricingModelTrigger: (pricingModel, pricing) ->
        payloadOptions = { pricing_model: pricingModel }
        modalOptions = { pricing_model: pricingModel, pricing }
        @$refs.updatePricingModelTrigger.fire(payloadOptions, modalOptions)
      hiRemoveSpecialPricingTrigger: (pricingModel) ->
        @triggerResource 'event', 'update_pricing_model', { pricing_model: pricingModel }
      onEventUpdatePricingModel: (data, response) ->
        @$refs.updatePricingModelTrigger.close()
        @fetch('event')
      hiRemoveGeoFenceTimeframeTrigger: (snapshot) ->
        @triggerResource 'event', 'remove_geo_fence_timeframe', { snapshot_id: snapshot.id }

      hiRecommendToCampaignsTrigger: () ->
        payloadOptions = { event_id: @event.id }
        modalOptions = { event: @event }
        @$refs.recommendToCampaignsTrigger.fire payloadOptions, modalOptions
      onEventRecommendEvent: () ->
        @$refs.recommendToCampaignsTrigger.close()

      hiMarkAsServiceTrigger: (service_type) ->
        @triggerResource 'event', 'mark_as_service', {service_type}
      onEventMarkAsService: () ->
        @$refs.markAsServiceTrigger.close()

      hiUnmarkAsServiceTrigger: ->
        @triggerResource 'event', 'unmark_as_service'
      onEventUnmarkAsService: ->
        @fetchAllResources()

      hiToggleIntantBookingTrigger: ->
        @triggerResource 'event', 'toggle_instant_booking'
      onEventToggleInstantBooking: ->
        @fetchAllResources()

      transferModal: ->
        organizerOptions = @prime?.context?.organizers || []
        orgsOptions = @prime?.context?.orgs || []

        {
          modalOptions:
            title: 'Transfer events'
            inputField:
              label: 'Organization'
              type: 'el-select'
              model: 'name'
            inputFields: [
              {
                model: 'organizer_id'
                type: 'el-select'
                label: 'Organizer'
                options: organizerOptions.map (org) ->
                  { id: org.id, name: "#{org.first_name} #{org.last_name}" }
              }
              {
                model: 'supplier_id'
                type: 'el-select'
                label: 'Organization'
                options: orgsOptions.map (org) ->
                  { id: org.id, name: org.name }
              }
            ]
            button:
              label: 'Transfer'
        }

      transferTriggerPayload: ->
        { event_id: @event.id, organizer_id: null, supplier_id: null }

      autoProjectingModal: ->
        if @event.enable_auto_projecting
          action = 'Disable'
          buttonType = 'danger'
        else
          action = 'Enable'
          buttonType = 'primary'

        modalOptions:
          title: "#{action} auto projecting?"
          button:
            label: action
            type: buttonType

      badgeSrc: (type) -> "#{process.env.VUE_APP_IMAGE_ENDPOINT}/indicators/recess_#{type}_badge.png"
      imageForSpace: (space) -> "#{process.env.VUE_APP_IMAGE_ENDPOINT}/spaces/#{space.type}.png"
      nextEventClicked: ->
        @$router.push({ name: 'EventShowPage', params: { eventId: @nextEvent.id, tab: 'super' } }) if @nextEvent
      previousEventClicked: ->
        @$router.push({ name: 'EventShowPage', params: { eventId: @previousEvent.id, tab: 'super' } }) if @previousEvent
      onCollectionUnloadItemCompleted: (event) ->
        @$router.push({ name: 'EventListPage' })

      actionPrompt: (action, label, options={}) ->
        op = (options.actionLabel || label).toLowerCase()
        title = "Would you like to #{op} this event?"
        show = true

        handler = () => @triggerResource 'event', action

        button = { label, handler }
        @actionModal = { title, show, action, button }

      promptToDeactivate: () ->
        @actionPrompt('deactivate', 'Deactivate')

      promptToReactivate: () ->
        @actionPrompt('reactivate', 'Reactivate')

      promptToPoke: () ->
        @actionPrompt('poke', 'Poke')

      promptToRecessVerify: () ->
        @actionPrompt('recess_verify', 'Recess Verify', { actionLabel: 'verify' })

      promptToRecessUnverify: () ->
        @actionPrompt('recess_unverify', 'Recess Unverify', { actionLabel: 'unverify' })

      promptToPotentialConfirmed: () ->
        @actionPrompt('potential_confirmed', 'Confirm')

      promptToPotentialDenied: () ->
        @actionPrompt('potential_denied', 'Deny')

      promptToCreateNextEvent: () ->
        @actionPrompt('create_next_event', 'Create Next Event')

      promptToPublish: () ->
        @actionPrompt('publish', 'Publish')

      promptToUnpublish: () ->
        @actionPrompt('unpublish', 'Unpublish')

      promptToCancelEvent: () ->
        @actionPrompt('cancel_event', 'Cancel Event', { actionLabel: 'cancel' })

      promptToUndoPotentialConfirmed: () ->
        @actionPrompt('undo_potential_confirmed', 'Undo Confirm')

      promptToUndoPotentialDenied: () ->
        @actionPrompt('undo_potential_denied', 'Undo Deny')

      promptToUndoCancelation: () ->
        @actionPrompt('undo_cancelation', 'Undo Cancelation')

      promptToDeleteEvent: () ->
        @actionPrompt('delete_event', 'Delete Event', { actionLabel: 'delete' })

      promptToAddToCampaign: () ->
        events = [@$route.params.id]
        @$router.push({ name: 'EventCampaignSelectorPage', params: { events } })

      onResourceTriggerCompleted: ->
        @actionModal.show = false

      addPrivateTagToSet: (tag) -> @triggerResource "event", 'add_private_tag_to_set', {tag: tag}
      untagSet: (tag) -> @triggerResource "event", 'untag_set', {tag: tag}

      projectNextEventTriggerResource: ->
        { key: 'event', triggerName: 'project_event_for_next_year', component: this }
      projectNextEventTriggerPayload: ->
        payload =
          event_ids: [@event.id]
        payload

      onEventProjectEventForNextYear: (data, response) ->
        @$router.push({ name: 'EventShowPage', params: { eventId: response.collection[0].id, tab: 'overview'} })

      onEventAddMemberNote: -> @fetch('event')
      onEventAddSuperNote: -> @fetch('event')
      onEventAddPublicTag: -> @fetch('event')
      onEventAddPrivateTag: -> @fetch('event')
      onEventAddPrivateTagToSet: -> @fetch('event')
      onEventUntag: -> @fetch('event')
      onEventUntagSet: -> @fetch('event')
      onEventAddPrivateStatusFlag: -> @fetch('event')
      onEventUnflag: -> @fetch('event')
      onEventConfigureAutoProjecting: -> @fetch('event')

      priceForVideoWall: -> PricingModel.priceForVideoWall @event, @marketplace.standard_pricing_table

    watch:
      '$route.params.eventId': -> @fetchAllResources()

export default VueOptions.vue settings
